/*eslint-disable no-undef */
/*eslint-disable no-unused-vars*/
const ImageViewer = function(transTarget, touchPanel){
    const _obj = {};

    // const transTarget = document.getElementById('transTarget');
    // const touchPanel = document.getElementById('touchPanel');
    const childCnt = transTarget.children.length;

    touchPanel.addEventListener('touchstart', touchPanelStart);
    touchPanel.addEventListener('touchmove', touchPanelMove);
    touchPanel.addEventListener('touchend', touchPanelEnd);

    let lastTranslate = 0;
    let curIndex = 0;
    const screentWidth = touchPanel.offsetWidth;

    function checkTranslate(){
        transTarget.style.transition = 'transform 0.3s ease';

        const baseX = curIndex * screentWidth;
        if(Math.abs(lastTranslate) < (baseX - screentWidth / 4)){
            if(curIndex > 0) {
                curIndex--;
                detectIndexChange(curIndex);
            }
        }else if(lastTranslate < 0 && Math.abs(lastTranslate) > (baseX + screentWidth / 4)){
            curIndex++;
            if(curIndex > childCnt - 1) curIndex = childCnt - 1;

            detectIndexChange(curIndex);
        }

        transTarget.style.transform = 'translateX(-' + screentWidth * curIndex + 'px)';
        lastTranslate = - screentWidth * curIndex;

        setTimeout(() => {
            transTarget.style.transition = 'unset';
        }, 300)
    }

    let touchPanelStartX = 0;
    let transTargetTranslateX = 0;

    function touchPanelStart(e){
        touchPanelStartX = e.touches[0].pageX;
        transTargetTranslateX = lastTranslate;
    }

    function touchPanelMove(e){
        const xDiff = e.touches[0].pageX - touchPanelStartX;

        transTarget.style.transform = 'translateX(' + (transTargetTranslateX + xDiff) + 'px)';
        lastTranslate = transTargetTranslateX + xDiff;
    }

    function touchPanelEnd(e){
        checkTranslate();
    }

    _obj.init = function(resizeTarget, imgScrollTarget){
        let startDistance = 0;
        let startWidth = 0;
        let width = resizeTarget.offsetWidth;
        let centerX = 0;
        let centerY = 0;
        let startLeft = 0;
        let startTop = 0;
        let xRatio = 0;
        let yRatio = 0;
        let isTouched = false;
        const xyRatio = resizeTarget.offsetHeight / resizeTarget.offsetWidth;
        const initWidth = resizeTarget.offsetWidth;
        const initHeight = resizeTarget.offsetHeight;
        let scrollLeft = 0;
        let scrollTop = 0;

        let isBorder = false;
        let leftOrRight = 0; //0왼쪽 1오른쪽
        let startX = 0;
        let startTranslate = 0;

        //이벤트 바인딩
        imgScrollTarget.addEventListener('touchstart', touchstart);
        imgScrollTarget.addEventListener('touchmove', touchmove)
        imgScrollTarget.addEventListener('touchend', touchend)

        function touchstart(e){
            e.stopPropagation();
            isTouched = true;

            if((e.touches.length > 1)){
                const dist = Math.hypot(e.touches[0].pageX - e.touches[1].pageX, e.touches[0].pageY - e.touches[1].pageY);

                centerX = Math.abs((e.touches[0].pageX + e.touches[1].pageX) / 2);
                centerY = Math.abs((e.touches[0].pageY + e.touches[1].pageY) / 2);

                startDistance = dist;
                startWidth = width;

                startLeft = imgScrollTarget.scrollLeft;
                startTop = imgScrollTarget.scrollTop;

                xRatio = (startLeft + centerX) / resizeTarget.offsetWidth;
                yRatio = (startTop + centerY) / resizeTarget.offsetHeight;

                // setTimeout(() => {
                //          animate();
                // }, 1)
                isBorder = false;
            }else {
                if(imgScrollTarget.scrollLeft === 0){
                    isBorder = true;
                    leftOrRight = 0;
                }else if((imgScrollTarget.scrollLeft + initWidth + 1) >= resizeTarget.offsetWidth){
                    isBorder = true;
                    leftOrRight = 1;
                } else {
                    isBorder = false;
                }
                startX = e.touches[0].pageX;
                startTranslate = lastTranslate;
            }
        }


        function touchmove(e){
            e.stopPropagation();
            //터치 둘이상
            if((e.touches.length > 1)){
                const dist = Math.hypot(e.touches[0].pageX - e.touches[1].pageX, e.touches[0].pageY - e.touches[1].pageY); //터치의 화면상 거리
                let difference = (dist - startDistance) * (resizeTarget.offsetWidth / initWidth);
                const curLeft = difference;

                //최소 크기 이하는 작아지지 않도록
                const tempWidth = (startWidth + difference)
                if(tempWidth < initWidth){
                    event.preventDefault();
                    return;

                    //일정 크기 이하일때는 최초 크기로 변경
                } else if(tempWidth < initWidth + 20){
                    imgScrollTarget.scrollLeft = 0 ;
                    imgScrollTarget.scrollTop = 0 ;
                    resizeTarget.style.width = initWidth + 'px';
                    event.preventDefault();
                    return;
                }

                width = tempWidth;

                // scrollLeft = startLeft + (curLeft * xRatio) ;
                // scrollTop = startTop + (curLeft * yRatio * xyRatio) ;
                imgScrollTarget.scrollLeft = startLeft + (curLeft * xRatio) ;
                imgScrollTarget.scrollTop = startTop + (curLeft * yRatio * xyRatio) ;
                resizeTarget.style.width = width + 'px';

                event.preventDefault();
                //하나만 터치 움직임
            }else {
                if(isBorder){
                    const xDiff = e.touches[0].pageX - startX;

                    if(initWidth === resizeTarget.offsetWidth
                        || xDiff > 0 && leftOrRight === 0 //오른쪽-> 스와이프
                        || xDiff <= 0 && leftOrRight === 1 //왼쪽<- 스와이프
                    ){
                        transTarget.style.transform = 'translateX(' + (startTranslate + xDiff) + 'px)';
                        lastTranslate = startTranslate + xDiff;
                    }
                }
            }
        }

        function touchend(e){
            e.stopPropagation();
            isTouched = false;
            checkTranslate();
        }


        // function animate(){
        //     resizeTarget.style.width = width + 'px';
        //     imgScrollTarget.scrollLeft = scrollLeft;
        //     imgScrollTarget.scrollTop = scrollTop;
        //     if(isTouched) requestAnimationFrame(animate);
        // }
    }

    _obj.goToPage = function(index){
        const translateX = - index * screentWidth;
        lastTranslate = translateX;
        curIndex = index;
        transTarget.style.transform = 'translateX(' + translateX + 'px)';
    };

    _obj.getCurIndex = function(){
        return curIndex;
    }

    let detectIndexChange = () => {};

    _obj.setDetectIndexChange = function(pDetectIndexChange){
        detectIndexChange = pDetectIndexChange;
    }

    return _obj;
}

export default ImageViewer;